import { createReducer, on } from '@ngrx/store';
import { setCache } from './cache.actions';
import { CacheConfig } from '@/app/_core/domain/models/cache/cache.model';

export interface CacheState {
  cache: CacheConfig;
}

export const initialCacheState: CacheState = {
  cache: null
};

export const reducer = createReducer<CacheState>(
  initialCacheState,
  on(setCache, (state, action) => ({
    ...state,
    cache: action.payload.cache
  }))
);
